export const withChips = (editor) => {
  const {isVoid, isInline} = editor;
  editor.isInline = (el) => el.type === "search-bar-chip" ? true : isInline(el);
  editor.isVoid = (el) => el.type === "search-bar-chip" ? true : isVoid(el);
  return editor;
};
